import React from "react";
import AssemblyDisassemblyOrdersGenericSkeleton from "./AssemblyDisassemblyOrdersGenericSkeleton";

function AssemblyDisassemblyOrdersDetailSkeleton() {
  return (
    <>
      <AssemblyDisassemblyOrdersGenericSkeleton />
    </>
  );
}

export default AssemblyDisassemblyOrdersDetailSkeleton;
